import React, { Component } from 'react'
import lang from '../lang'
import './index.less'
import score from 'src/helper/score'

export default class extends Component {
  render() {
    let { language, lang, rankList, funcTabBarRank, closeFuncTabBarRank } = this.props
    return (
      <div
        className={`lot-rank-wrap ${language == 'ar' && 'arlang'}`}
        style={{ display: funcTabBarRank == '1' ? 'block' : 'none' }}
      >
        <div className="lot-rank-box">
          <div className="close" onClick={() => { closeFuncTabBarRank() }}></div>
          <div className="lot-rank-title">{lang.rank}</div>
          <div className="lot-rank-content">
            <div className="rank-one" style={{ display: rankList && rankList.length > 0 ? 'flex' : 'none' }}>
              <div className="medal">
                <img src="/img/activity/fruitgame/index-1.png" alt="" />
              </div>
              <div className="ava">
                <img src={(rankList && rankList.length > 0 && rankList[0] && rankList[0].avatarurl) || ''} alt="" />
              </div>
              <div className="info">
                <div className="name">
                  {(rankList && rankList.length > 0 && rankList[0] && rankList[0].nickname) || ''}
                </div>
                <div className="idInfo">
                  <div className="id">ID</div>
                  <div className="fh">:</div>
                  <div className="sz">{(rankList && rankList.length > 0 && rankList[0] && rankList[0].duid) || ''}</div>
                </div>
              </div>
              <div className="score">
                <img src="/img/activity/lottery/jb.png" alt="" />
                <span>{score(rankList && rankList.length > 0 && rankList[0] && rankList[0].val)}</span>
              </div>
            </div>
            <div className="rank-two" style={{ display: rankList && rankList.length > 1 ? 'flex' : 'none' }}>
              <div className="medal">
                <img src="/img/activity/fruitgame/index-2.png" alt="" />
              </div>
              <div className="ava">
                <img src={(rankList && rankList.length > 1 && rankList[1] && rankList[1].avatarurl) || ''} alt="" />
              </div>
              <div className="info">
                <div className="name">
                  {(rankList && rankList.length > 1 && rankList[1] && rankList[1].nickname) || ''}
                </div>
                <div className="idInfo">
                  <div className="id">ID</div>
                  <div className="fh">:</div>
                  <div className="sz">{(rankList && rankList.length > 1 && rankList[1] && rankList[1].duid) || ''}</div>
                </div>
              </div>
              <div className="score">
                <img src="/img/activity/lottery/jb.png" alt="" />
                <span>{score(rankList && rankList.length > 1 && rankList[1] && rankList[1].val)}</span>
              </div>
            </div>
            <div className="rank-three" style={{ display: rankList && rankList.length > 2 ? 'flex' : 'none' }}>
              <div className="medal">
                <img src="/img/activity/fruitgame/index-3.png" alt="" />
              </div>
              <div className="ava">
                <img src={(rankList && rankList.length > 2 && rankList[2] && rankList[2].avatarurl) || ''} alt="" />
              </div>
              <div className="info">
                <div className="name">
                  {(rankList && rankList.length > 2 && rankList[2] && rankList[2].nickname) || ''}
                </div>
                <div className="idInfo">
                  <div className="id">ID</div>
                  <div className="fh">:</div>
                  <div className="sz">{(rankList && rankList.length > 2 && rankList[2] && rankList[2].duid) || ''}</div>
                </div>
              </div>
              <div className="score">
                <img src="/img/activity/lottery/jb.png" alt="" />
                <span>{score(rankList && rankList.length > 2 && rankList[2] && rankList[2].val)}</span>
              </div>
            </div>

            {rankList &&
              rankList.length > 0 &&
              rankList
                .filter((ele, index) => {
                  return index > 2 // 排除前三
                })
                .map((item, index) => {
                  if (index < 7) {
                    // 限制多少条
                    // 前10
                    return (
                      <div className="rank-others" key={index}>
                        <div className="medal">{item.rank}</div>
                        <div className="ava">
                          <img src={item.avatarurl} alt="" />
                        </div>
                        <div className="info">
                          <div className="name">{item.nickname}</div>
                          <div className="idInfo">
                            <div className="id">ID</div>
                            <div className="fh">:</div>
                            <div className="sz">{item.duid}</div>
                          </div>
                        </div>
                        <div className="score">
                          <img src="/img/activity/lottery/jb.png" alt="" />
                          <span>{score(item.val)}</span>
                        </div>
                      </div>
                    )
                  }
                })}
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/activity/lottery/Rank/index.js